(function () {
  'use strict';
  function init() {
    const normalize = value => decodeURIComponent(new URL(value, location.origin).pathname).normalize('NFC').replace(/\/$/, '');
    const sources = new Map(Object.entries(window.FREYA_PRODUCT_SPINS || {}).map(([url, config]) => [normalize(url), config]));
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const hover = matchMedia('(hover: hover) and (pointer: fine)');
    const touch = matchMedia('(hover: none) and (pointer: coarse)');
    const controllers = new Map();
    const visibleGalleries = new Set();
    let selectedGallery = null;
    function previewVisibleProduct() {
      if (document.hidden || !touch.matches || reduced.matches || navigator.connection?.saveData) return;
      if (visibleGalleries.has(selectedGallery)) return;
      selectedGallery?.stop();
      selectedGallery = visibleGalleries.values().next().value || null;
      selectedGallery?.start('viewport');
    }
    const touchObserver = new IntersectionObserver(entries => {
      for (const entry of entries) {
        const controller = controllers.get(entry.target.closest('.product-card'));
        if (!controller) continue;
        if (entry.intersectionRatio >= 0.55) visibleGalleries.add(controller);
        else visibleGalleries.delete(controller);
      }
      previewVisibleProduct();
    }, { threshold: [0, 0.55] });
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (!entry.isIntersecting) controllers.get(entry.target)?.stop(); });
    });
    function bind() {
      controllers.forEach((controller, card) => {
        if (!card.isConnected) {
          controller.stop();
          observer.unobserve(card);
          touchObserver.unobserve(controller.frame);
          visibleGalleries.delete(controller);
          if (selectedGallery === controller) selectedGallery = null;
          controllers.delete(card);
        }
      });
      document.querySelectorAll('.freya-home-product, #catalog-grid .product-card').forEach(card => {
        if (controllers.has(card)) return;
        const link = card.querySelector('a[href^="/products/"]');
        const product = (window.FREYA_PRODUCTS || []).find(p => p.slug === card.dataset.slug);
        const url = link?.getAttribute('href') || product?.url;
        const frame = card.querySelector('.product-photo-pair, .product-gallery-stage');
        const config = url && sources.get(normalize(url));
        const source = typeof config === 'string' ? config : config?.src;
        const turns = typeof config === 'object' ? config.turns || 1 : 1;
        if (!frame || !source) return;
        const catalogCard = !!card.closest('#catalog-grid');
        const video = document.createElement('video');
        video.className = 'freya-spin-video';
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = 'none';
        video.setAttribute('aria-hidden', 'true');
        video.setAttribute('disablepictureinpicture', '');
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'freya-spin-toggle';
        if (catalogCard) {
          toggle.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><g class="freya-spin-start"><path d="M20 7v5h-5"/><path d="M19.5 11a7.5 7.5 0 1 0-2 6.4"/></g><g class="freya-spin-stop"><path d="M9 6v12m6-12v12" stroke-width="3"/></g></svg>';
        }
        const productName = card.querySelector('h3').textContent;
        function updateToggle(playing) {
          toggle.setAttribute('aria-pressed', String(playing));
          toggle.setAttribute('aria-label', productName + (playing ? ' — dönüşü durdur' : ' — 360 derece döndür'));
          if (!catalogCard) toggle.textContent = playing ? 'Durdur' : '360°';
        }
        updateToggle(false);
        (card.querySelector('.product-gallery') || card).append(toggle);
        frame.append(video);
        frame.dataset.spinReady = '';
        let wanted = false, manual = false, generation = 0;
        const stop = () => {
          wanted = manual = false;
          generation++;
          video.pause();
          delete frame.dataset.spinActive;
          updateToggle(false);
          if (video.readyState > 0) video.currentTime = 0;
        };
        const start = async mode => {
          if (document.hidden || (mode === 'hover' && !hover.matches)) return;
          if (mode !== 'button' && (reduced.matches || navigator.connection?.saveData)) return;
          controllers.forEach(c => { if (c.stop !== stop && c.isPlaying()) c.stop(); });
          wanted = true;
          manual = mode === 'button';
          const request = ++generation;
          if (!video.getAttribute('src')) video.src = source;
          try {
            await video.play();
            if (!wanted || request !== generation) return;
            frame.dataset.spinActive = '';
            updateToggle(true);
          } catch { if (request === generation) stop(); }
        };
        video.addEventListener('loadedmetadata', () => {
          if (Number.isFinite(video.duration) && video.duration > 0) video.playbackRate = video.duration / (6 * turns);
        });
        video.addEventListener('error', stop);
        frame.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') start('hover'); });
        frame.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse' && !manual) stop(); });
        const focusTarget = link || frame;
        focusTarget.addEventListener('focus', () => start('hover'));
        focusTarget.addEventListener('blur', () => { if (hover.matches && !manual) stop(); });
        toggle.addEventListener('click', () => {
          if (catalogCard && touch.matches && visibleGalleries.has(controller)) selectedGallery = controller;
          if (wanted && frame.hasAttribute('data-spin-active')) stop();
          else start('button');
        });
        card.addEventListener('click', e => {
          if (e.target.closest('.gallery-controls, .js-open')) stop();
        });
        frame.addEventListener('pointerdown', e => { if (e.pointerType === 'mouse' && wanted) stop(); });
        card.addEventListener('keydown', e => { if (['Escape', 'ArrowLeft', 'ArrowRight'].includes(e.key)) stop(); });
        const controller = { frame, start, stop, isPlaying: () => wanted };
        controllers.set(card, controller);
        observer.observe(card);
        if (catalogCard) touchObserver.observe(frame);
      });
    }
    bind();
    const catalog = document.getElementById('catalog-grid');
    if (catalog) new MutationObserver(bind).observe(catalog, {childList: true, subtree: true});
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        selectedGallery = null;
        controllers.forEach(c => c.stop());
      } else previewVisibleProduct();
    });
    reduced.addEventListener('change', () => controllers.forEach(c => c.stop()));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
